"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var SmallSpinnerSVG = function SmallSpinnerSVG(_ref) {
  var color = _ref.color,
    _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === void 0 ? 0 : _ref$thickness;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-hidden": "true",
    "data-testid": "spinner-sm-svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMaxYMax",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: color,
      stroke: color
    },
    strokeWidth: thickness,
    fillRule: "evenodd",
    d: "M8 0.5C8.21094 0.5 8.38672 0.576172 8.52734 0.728516C8.67969 0.869141 8.75586 1.04492 8.75586 1.25586C8.75586 1.45508 8.67969 1.63086 8.52734 1.7832C8.38672 1.92383 8.21094 1.99414 8 1.99414C7.16797 1.99414 6.38867 2.15234 5.66211 2.46875C4.93555 2.78516 4.29688 3.21875 3.74609 3.76953C3.20703 4.30859 2.7793 4.94141 2.46289 5.66797C2.1582 6.39453 2.00586 7.17383 2.00586 8.00586C2.00586 8.82617 2.1582 9.60547 2.46289 10.3438C2.7793 11.0703 3.20703 11.7031 3.74609 12.2422C4.29688 12.7812 4.93555 13.209 5.66211 13.5254C6.38867 13.8418 7.16797 14 8 14C8.83203 14 9.61133 13.8418 10.3379 13.5254C11.0645 13.209 11.6973 12.7812 12.2363 12.2422C12.7871 11.7031 13.2207 11.0703 13.5371 10.3438C13.8418 9.60547 13.9941 8.82617 13.9941 8.00586C13.9941 7.79492 14.0645 7.61914 14.2051 7.47852C14.3574 7.32617 14.5391 7.25 14.75 7.25C14.9609 7.25 15.1367 7.32617 15.2773 7.47852C15.4297 7.61914 15.5059 7.79492 15.5059 8.00586C15.5059 9.03711 15.3066 10.0098 14.9082 10.9238C14.5215 11.8262 13.9883 12.6172 13.3086 13.2969C12.6289 13.9766 11.832 14.5156 10.918 14.9141C10.0039 15.3008 9.03125 15.4941 8 15.4941C6.96875 15.4941 5.99609 15.3008 5.08203 14.9141C4.16797 14.5156 3.37109 13.9766 2.69141 13.2969C2.01172 12.6172 1.47852 11.8262 1.0918 10.9238C0.693359 10.0098 0.494141 9.03711 0.494141 8.00586C0.494141 6.96289 0.693359 5.99023 1.0918 5.08789C1.47852 4.17383 2.01172 3.37695 2.69141 2.69727C3.37109 2.01758 4.16797 1.48438 5.08203 1.09766C5.99609 0.699219 6.96875 0.5 8 0.5Z"
  }));
};
var _default = exports["default"] = SmallSpinnerSVG;